import { render } from "./BaseReservationForm.vue?vue&type=template&id=60e8542f&scoped=true"
import script from "./BaseReservationForm.vue?vue&type=script&lang=ts"
export * from "./BaseReservationForm.vue?vue&type=script&lang=ts"

import "./BaseReservationForm.vue?vue&type=style&index=0&id=60e8542f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60e8542f"

export default script